import React, {FC} from "react";
import styles from "./styles.module.scss";
import {useTranslation} from "react-i18next";
import {classnames} from '../../utils'

export interface ToggleTabsProps {
    options: {label: string, value: string }[];
    value: string ;
    onChange: (option:{label:string,value:string }) => void;
}

const ToggleTabs: FC<ToggleTabsProps> = ({ options, value, onChange }) => {
    const { t } = useTranslation();
    return (
        <div className={styles.toggleWrapper}>
            {options.map((option) => (
                <button
                    key={option.value}
                    type="button"
                    className={classnames({
                    [styles.toggleButton]: true,
                    [styles.active]: value === option.value
                    })}
                    onClick={() => onChange(option)}
                >
                    {t(option.label)}
                </button>
            ))}
        </div>
    );
};

export default ToggleTabs;
